import Environment from 'b2b-ui-components-lib/lib/services/environment';
export const Base_Href = process.env.APP_BASE_HREF || '';
export const APP_ENV_MODE = process.env.APP_ENV;

export const ENV_NAME_ASSETS = {
  PROD: 'prod',
  QA: 'qa',
  QA2: 'qa',
  PREPROD2: 'qa',
  PREPROD4: 'qa',
  DEV: 'dev'
};

export const ENV_NAME = {
  PROD: 'PROD',
  QA: 'QA',
  QA2: 'QA2',
  PREPROD2: 'PREPROD2',
  PREPROD4: 'PREPROD4',
  DEV: 'DEV'
};

const IP = {
  DEV: 'http://10.222.236.232',
  QA: 'http://10.5.245.148'
};

const MODULE = {
  DEV: {
    COCP: `${IP.DEV}:8012/b2b-cocp-acquisition/`,
    PNQ: `${IP.DEV}:8018/b2b-pricing-quotation/`,
    KYC: `${IP.DEV}:8080/b2b-acquisition-kyc/`,
    OFT: `${IP.QA}:8009/b2b-oft/`
  }
};

const _Environment = {
  [ENV_NAME.PROD]: {
    env: ENV_NAME.PROD,
    baseAssetsUrl: 'https://assets.airtel.in/static-assets/',
    apiBaseUrl: 'https://digi-api.airtel.in/us/b2b-cocp-acquisition/',
    dedicatedSummaryApiUrl: 'https://digi-api.airtel.in/b2b-acquisition-kyc/',
    dedicatedSummaryAuthApiUrl: 'https://digi-api.airtel.in/b2b-acquisition-kyc/',
    apiCallAEHUrl: 'https://digi-api.airtel.in/s/b2b-cocp-acquisition/',
    selfcareHelpPageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/',
    aehdashboardUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/',
    selfcareProfilePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/user/profile/',
    selfcareLoginPageBaseUrl: 'https://www.airtel.in/business/thanksforbusiness/login/',
    selfcareBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/',
    homePageUrl: 'https://www.airtel.in/business/b2b/broadband-internet/',
    dedicatedhomePageUrl: 'https://www.airtel.in/business/b2b/internet-leased-line',
    autocomplete: 'https://digi-api.airtel.in/compassLocation/rest/',
    oftApiBaseUrl: 'https://digi-api.airtel.in/b2b-oft/',
    dedicatedoftApiBaseUrl: 'https://digi-api.airtel.in/b2b-oft/',
    otpApiBaseUrl: 'https://digi-api.airtel.in/passport/services/oauth/v1_1/authorize?response_type=code&client_id=b2b_dsl_dev&redirect_uri=http://localhost:3001/home/',
    // change both to prod
    authClientId: 'b2b_dsl_prod',
    authRedirectUri: 'https://www.airtel.in/business/b2b/broadband-internet/check-feasibility',
    getCitiesUrl: 'https://digi-api.airtel.in/telemedia-broadband/rest/bbData/',
    profileUnauthBaseUrl: 'https://digi-api.airtel.in/as/app/b2b-api/airtel-b2b-profile/rest/',
    profileBaseUrl: 'https://digi-api.airtel.in/s/app/b2b-api/airtel-b2b-profile/rest/',
    notificationBaseUrl: 'https://digi-api.airtel.in/s/app/b2b-api/b2b-notification-manager/rest/',
    oftCheckFeasibilityApi: 'https://digi-api.airtel.in/b2b-oft/feasibility/common-widget/check',
    recommendedFeasibilityOftApi: 'https://digi-api.airtel.in/b2b-oft/',
    staticAssetsUrl: 'https://assets.airtel.in/static-assets/thanksforbusiness-ui/',
    pnqapiBaseUrl: 'https://digi-api.airtel.in/b2b-pricing-quotation/',
    pnqLoginApiBaseUrl: 'https://digi-api.airtel.in/s/b2b-pricing-quotation/',
    kamTrackLeadPage: ' https://www.airtel.in/business/thanksforbusiness/selfcare/data/track-orders/dashboard',
    kycApiBaseUrl: 'https://digi-api.airtel.in/b2b-kyc/',
    directVPNPageUrl: 'https://www.airtel.in/business/b2b/direct-vpn',
    getCityByPincodeApi: 'https://digi-api.airtel.in/b2b-oft/pincodeMaster',
    ovapiBaseUrl: 'https://digi-api.airtel.in/b2b-ov'
  },
  [ENV_NAME.QA]: {
    env: ENV_NAME.QA,
    baseAssetsUrl: 'https://devassets.airtel.com/static-assets/',
    apiBaseUrl: '//test.airtel.in/kas/app/b2b-api-t1/b2b-cocp-acquisition/',
    apiCallAEHUrl: '//test.airtel.in/ks/app/b2b-api-t1/b2b-cocp-acquisition/',
    dedicatedSummaryApiUrl: '//test.airtel.in/kas/app/b2b-api-t1/b2b-acquisition-kyc/',
    dedicatedSummaryAuthApiUrl: '//test.airtel.in/kas/app/b2b-api-t1/b2b-acquisition-kyc/',
    pnqapiBaseUrl: '//test.airtel.in/kas/app/b2b-api/b2b-pricing-quotation/',
    pnqLoginApiBaseUrl: '//test.airtel.in/ks/app/b2b-api/b2b-pricing-quotation/',

    selfcareHelpPageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/', // global
    selfcareProfilePageUrl: 'https://test.airtel.in/b2b-t1/business/enterprise-hub/data/dashboard/profile/', // global
    homePageUrl: 'https://test.airtel.in/acquisition/acq/online-acquisition/',
    dedicatedhomePageUrl: 'https://www.airtel.in/business/b2b/internet-leased-line', // env specific
    selfcareBasePageUrl: 'https://test.airtel.in/atb-integration/business/enterprise-hub/data/dashboard/',
    aehdashboardUrl: 'https://test.airtel.in/atb-integration/business/enterprise-hub/data/dashboard', // env specific
    oftApiBaseUrl: '//test.airtel.in/ks/app/b2b-api-t1/b2b-oft/',
    dedicatedoftApiBaseUrl: '//test.airtel.in/kas/app/b2b-api-t1/b2b-oft/',
    otpApiBaseUrl:
      'http://10.5.245.149:8081/passport/services/oauth/v1_1/authorize?response_type=code&client_id=b2b_dsl_sit&redirect_uri=http://125.16.74.78/business/acq/online-acquisition/check-feasibility',
    autocomplete: 'https://digi-api.airtel.in/compassLocation/rest/',
    authClientId: 'b2b_dsl_sit',
    authRedirectUri: 'https://test.airtel.in/acquisition/acq/online-acquisition//check-feasibility',
    getCitiesUrl: 'http://10.5.204.217/telemedia-broadband/rest/bbData/',
    profileUnauthBaseUrl: 'https://test.airtel.in/kas/app/b2b-api-t1/airtel-b2b-profile/rest/',
    profileBaseUrl: 'https://test.airtel.in/ks/app/b2b-api-t1/airtel-b2b-profile/rest/',
    notificationBaseUrl: 'https://test.airtel.in/ks/app/b2b-api-t1/b2b-notification-manager/rest/',
    dataManageAccountBasePageUrl: 'https://test.airtel.in/b2b-t1/user/',
    mobilityManageAccountBasePageUrl: 'https://test.airtel.in/b2b-t1/cocp-admin-billing/profile',
    changePasswordBasePageUrl: 'https://test.airtel.in/b2b-t1/cocp-admin-billing/change-password',
    gettingStartedBasePageUrl: 'https://test.airtel.in/b2b-t1/help-support/lob/lob_enterprisehub#category_enterprisehub_level1_gettingstarted',
    helpAndSupportBasePageUrl: 'https://test.airtel.in/b2b-t1/help-support/',
    moreResourcesBasePageUrl: '',
    payDataBasePageUrl: 'https://test.airtel.in/b2b-t1/billing/',
    circuitsBasePageUrl: 'https://test.airtel.in/b2b-t1/circuits/',
    dataSRBasePageUrl: 'https://test.airtel.in/b2b-t1/sr/sr/',
    dataTrackOrderBasePageUrl: 'https://www.airtel.in/business/b2b/acquisition/track-order',
    cocpBillingBasePageUrl: 'https://test.airtel.in/b2b-t1/cocp-admin-billing/mobility/billing/',
    cocpConnectionBasePageUrl: 'https://test.airtel.in/b2b-t1/cocp-admin-connections/mobility/connection',
    cocpSRBaseUrl: 'https://test.airtel.in/aeh-uat2/cocp-sr/',
    cocpTrackOrderBasePageUrl: 'https://test.airtel.in/b2b-t1/trackorder/track-order/',
    gsuiteManageUsersUrl: 'https://test.airtel.in/blackforest-preprod/manage-users',
    thanksBasePageUrl: 'https://test.airtel.in/b2b-t1/b2b-thanks-ui/thanks-connections',
    buyBroadbandBaseUrl: 'https://www.airtel.in/business/b2b/acquisition/corporate-broadband/',
    oftCheckFeasibilityApi: '//test.airtel.in/kas/app/b2b-api-t1/b2b-oft/feasibility/common-widget/check',
    recommendedFeasibilityOftApi: '//test.airtel.in/kas/app/b2b-api-t1/b2b-oft/',
    staticAssetsUrl: 'https://devassets.airtel.com/static-assets/thanksforbusiness-ui/',

    kamTrackLeadPage: 'https://test.airtel.in/business/b2b/acquisition/track-order/requests',
    kycApiBaseUrl: '//test.airtel.in/kas/app/b2b-api/b2b-kyc/',
    selfcareLoginPageBaseUrl: 'https://test.airtel.in/atb-integration/business/thanksforbusiness/login/',
    directVPNPageUrl: 'https://www.airtel.in/business/b2b/direct-vpn',
    getCityByPincodeApi: '//test.airtel.in/kas/app/b2b-api-t1/b2b-oft/pincodeMaster',
    ovapiBaseUrl: 'http://10.5.245.145:8006/b2b-ov'
  },
  [ENV_NAME.QA2]: {
    env: ENV_NAME.QA2,
    baseAssetsUrl: 'https://devassets.airtel.com/static-assets/',
    apiBaseUrl: '//test.airtel.in/kas/app/b2b-cocp-acquisition-sit/',
    dedicatedSummaryApiUrl: '//test.airtel.in/kas/app/qa2/b2b-acquisition-kyc/',
    dedicatedSummaryAuthApiUrl: '//test.airtel.in/kas/app/qa2/b2b-acquisition-kyc/',
    apiCallAEHUrl: '//test.airtel.in/ks/app/b2b-cocp-acquisition-sit/',
    pnqapiBaseUrl: '//test.airtel.in/kas/app/b2b-pricing-quotation-sit/',
    pnqLoginApiBaseUrl: '//test.airtel.in/ks/app/b2b-pricing-quotation-sit/',

    selfcareHelpPageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/',
    selfcareProfilePageUrl: 'https://test.airtel.in/b2b-t1/business/enterprise-hub/data/dashboard/profile/',
    homePageUrl: 'https://test.airtel.in/acquisition/acq/online-acquisition/',
    dedicatedhomePageUrl: 'https://www.airtel.in/business/b2b/internet-leased-line',
    selfcareBasePageUrl: 'https://test.airtel.in/atb-integration/business/enterprise-hub/data/dashboard/',
    aehdashboardUrl: 'https://test.airtel.in/b2b-t1/business/enterprise-hub/data/dashboard',
    oftApiBaseUrl: '//test.airtel.in/ks/app/b2b-api-t1/b2b-oft/',
    //oftApiBaseUrl: "https://digi-api.airtel.in/b2b-oft/",
    //dedicatedoftApiBaseUrl:  "https://digi-api.airtel.in/b2b-oft/",
    dedicatedoftApiBaseUrl: '//test.airtel.in/kas/app/b2b-api-t1/b2b-oft/',
    otpApiBaseUrl:
      'http://10.5.245.149:8081/passport/services/oauth/v1_1/authorize?response_type=code&client_id=b2b_dsl_sit&redirect_uri=http://125.16.74.78/business/acq/online-acquisition/check-feasibility',
    autocomplete: 'https://digi-api.airtel.in/compassLocation/rest/',
    authClientId: 'b2b_dsl_sit',
    authRedirectUri: 'https://test.airtel.in/acquisition/acq/online-acquisition//check-feasibility',
    getCitiesUrl: 'http://10.5.204.217/telemedia-broadband/rest/bbData/',
    profileUnauthBaseUrl: 'https://test.airtel.in/kas/app/b2b-api-t1/airtel-b2b-profile/rest/',
    profileBaseUrl: 'https://test.airtel.in/ks/app/b2b-api-t1/airtel-b2b-profile/rest/',
    notificationBaseUrl: 'https://test.airtel.in/ks/app/b2b-api-t1/b2b-notification-manager/rest/',
    dataManageAccountBasePageUrl: 'https://test.airtel.in/b2b-t1/user/',
    mobilityManageAccountBasePageUrl: 'https://test.airtel.in/b2b-t1/cocp-admin-billing/profile',
    changePasswordBasePageUrl: 'https://test.airtel.in/b2b-t1/cocp-admin-billing/change-password',
    gettingStartedBasePageUrl: 'https://test.airtel.in/b2b-t1/help-support/lob/lob_enterprisehub#category_enterprisehub_level1_gettingstarted',
    helpAndSupportBasePageUrl: 'https://test.airtel.in/b2b-t1/help-support/',
    moreResourcesBasePageUrl: '',
    payDataBasePageUrl: 'https://test.airtel.in/b2b-t1/billing/',
    circuitsBasePageUrl: 'https://test.airtel.in/b2b-t1/circuits/',
    dataSRBasePageUrl: 'https://test.airtel.in/b2b-t1/sr/sr/',
    dataTrackOrderBasePageUrl: 'https://www.airtel.in/business/b2b/acquisition/track-order',
    cocpBillingBasePageUrl: 'https://test.airtel.in/b2b-t1/cocp-admin-billing/mobility/billing/',
    cocpConnectionBasePageUrl: 'https://test.airtel.in/b2b-t1/cocp-admin-connections/mobility/connection',
    cocpSRBaseUrl: 'https://test.airtel.in/aeh-uat2/cocp-sr/',
    cocpTrackOrderBasePageUrl: 'https://test.airtel.in/b2b-t1/trackorder/track-order/',
    gsuiteManageUsersUrl: 'https://test.airtel.in/blackforest-preprod/manage-users',
    thanksBasePageUrl: 'https://test.airtel.in/b2b-t1/b2b-thanks-ui/thanks-connections',
    buyBroadbandBaseUrl: 'https://www.airtel.in/business/b2b/acquisition/corporate-broadband/',
    oftCheckFeasibilityApi: '//test.airtel.in/kas/app/b2b-api-t1/b2b-oft/feasibility/common-widget/check',
    recommendedFeasibilityOftApi: '//test.airtel.in/kas/app/b2b-api-t1/b2b-oft/',
    staticAssetsUrl: 'https://devassets.airtel.com/static-assets/thanksforbusiness-ui/',

    kamTrackLeadPage: 'https://test.airtel.in/business/b2b/acquisition/track-order/requests',
    kycApiBaseUrl: 'https://digi-api.airtel.in/b2b-kyc/',
    selfcareLoginPageBaseUrl: 'https://test.airtel.in/atb-integration/business/thanksforbusiness/login/',
    directVPNPageUrl: 'https://www.airtel.in/business/b2b/direct-vpn',
    getCityByPincodeApi: '//test.airtel.in/kas/app/b2b-api-t1/b2b-oft/pincodeMaster',
    ovapiBaseUrl: '//test.airtel.in/as/app/b2b-ov'
  },
  [ENV_NAME.PREPROD2]: {
    env: ENV_NAME.PREPROD2,
    baseAssetsUrl: 'https://devassets.airtel.com/static-assets/',
    apiBaseUrl: '//test.airtel.in/kas/app/b2b-cocp-acquisition-preprod2/',
    dedicatedSummaryApiUrl: '//test.airtel.in/kas/app/preprod2/b2b-acquisition-kyc/',
    dedicatedSummaryAuthApiUrl: '//test.airtel.in/kas/app/preprod2/b2b-acquisition-kyc/',
    apiCallAEHUrl: '//test.airtel.in/ks/app/b2b-cocp-acquisition-preprod2/',
    pnqapiBaseUrl: '//test.airtel.in/kas/app/b2b-pricing-quotation-preprod2/',
    pnqLoginApiBaseUrl: '//test.airtel.in/ks/app/b2b-pricing-quotation-preprod2/',

    selfcareHelpPageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/',
    selfcareProfilePageUrl: 'https://test.airtel.in/b2b-t1/business/enterprise-hub/data/dashboard/profile/',
    homePageUrl: 'https://test.airtel.in/acquisition/acq/online-acquisition/',
    dedicatedhomePageUrl: 'https://www.airtel.in/business/b2b/internet-leased-line',
    selfcareBasePageUrl: 'https://test.airtel.in/atb-integration/business/enterprise-hub/data/dashboard/',
    aehdashboardUrl: 'https://test.airtel.in/b2b-t1/business/enterprise-hub/data/dashboard',
    oftApiBaseUrl: '//test.airtel.in/ks/app/b2b-api-t1/b2b-oft/',
    //oftApiBaseUrl: "https://digi-api.airtel.in/b2b-oft/",
    //dedicatedoftApiBaseUrl:  "https://digi-api.airtel.in/b2b-oft/",
    dedicatedoftApiBaseUrl: '//test.airtel.in/kas/app/b2b-api-t1/b2b-oft/',
    otpApiBaseUrl:
      'http://10.5.245.149:8081/passport/services/oauth/v1_1/authorize?response_type=code&client_id=b2b_dsl_sit&redirect_uri=http://125.16.74.78/business/acq/online-acquisition/check-feasibility',
    autocomplete: 'https://digi-api.airtel.in/compassLocation/rest/',
    authClientId: 'b2b_dsl_sit',
    authRedirectUri: 'https://test.airtel.in/acquisition/acq/online-acquisition//check-feasibility',
    getCitiesUrl: 'http://10.5.204.217/telemedia-broadband/rest/bbData/',
    profileUnauthBaseUrl: 'https://test.airtel.in/kas/app/b2b-api-t1/airtel-b2b-profile/rest/',
    profileBaseUrl: 'https://test.airtel.in/ks/app/b2b-api-t1/airtel-b2b-profile/rest/',
    notificationBaseUrl: 'https://test.airtel.in/ks/app/b2b-api-t1/b2b-notification-manager/rest/',
    dataManageAccountBasePageUrl: 'https://test.airtel.in/b2b-t1/user/',
    mobilityManageAccountBasePageUrl: 'https://test.airtel.in/b2b-t1/cocp-admin-billing/profile',
    changePasswordBasePageUrl: 'https://test.airtel.in/b2b-t1/cocp-admin-billing/change-password',
    gettingStartedBasePageUrl: 'https://test.airtel.in/b2b-t1/help-support/lob/lob_enterprisehub#category_enterprisehub_level1_gettingstarted',
    helpAndSupportBasePageUrl: 'https://test.airtel.in/b2b-t1/help-support/',
    moreResourcesBasePageUrl: '',
    payDataBasePageUrl: 'https://test.airtel.in/b2b-t1/billing/',
    circuitsBasePageUrl: 'https://test.airtel.in/b2b-t1/circuits/',
    dataSRBasePageUrl: 'https://test.airtel.in/b2b-t1/sr/sr/',
    dataTrackOrderBasePageUrl: 'https://www.airtel.in/business/b2b/acquisition/track-order',
    cocpBillingBasePageUrl: 'https://test.airtel.in/b2b-t1/cocp-admin-billing/mobility/billing/',
    cocpConnectionBasePageUrl: 'https://test.airtel.in/b2b-t1/cocp-admin-connections/mobility/connection',
    cocpSRBaseUrl: 'https://test.airtel.in/aeh-uat2/cocp-sr/',
    cocpTrackOrderBasePageUrl: 'https://test.airtel.in/b2b-t1/trackorder/track-order/',
    gsuiteManageUsersUrl: 'https://test.airtel.in/blackforest-preprod/manage-users',
    thanksBasePageUrl: 'https://test.airtel.in/b2b-t1/b2b-thanks-ui/thanks-connections',
    buyBroadbandBaseUrl: 'https://www.airtel.in/business/b2b/acquisition/corporate-broadband/',
    oftCheckFeasibilityApi: '//test.airtel.in/kas/app/b2b-api-t1/b2b-oft/feasibility/common-widget/check',
    recommendedFeasibilityOftApi: '//test.airtel.in/kas/app/b2b-api-t1/b2b-oft/',
    staticAssetsUrl: 'https://devassets.airtel.com/static-assets/thanksforbusiness-ui/',

    kamTrackLeadPage: 'https://test.airtel.in/business/b2b/acquisition/track-order/requests',
    kycApiBaseUrl: '//test.airtel.in/kas/app/b2b-api/b2b-kyc/',
    selfcareLoginPageBaseUrl: 'https://test.airtel.in/atb-integration/business/thanksforbusiness/login/',
    directVPNPageUrl: 'https://www.airtel.in/business/b2b/direct-vpn',
    getCityByPincodeApi: '//test.airtel.in/kas/app/b2b-api-t1/b2b-oft/pincodeMaster',
    ovapiBaseUrl: 'http://10.5.245.145:8006/b2b-ov'
  },
  [ENV_NAME.PREPROD4]: {
    env: ENV_NAME.PREPROD4,
    baseAssetsUrl: 'https://devassets.airtel.com/static-assets/',
    apiBaseUrl: '//test.airtel.in/kas/app/b2b-cocp-acquisition-preprod4/',
    dedicatedSummaryApiUrl: '//test.airtel.in/kas/app/preprod4/b2b-acquisition-kyc/',
    dedicatedSummaryAuthApiUrl: '//test.airtel.in/kas/app/preprod4/b2b-acquisition-kyc/',
    apiCallAEHUrl: '//test.airtel.in/ks/app/b2b-cocp-acquisition-preprod4/',
    pnqapiBaseUrl: '//test.airtel.in/kas/app/b2b-pricing-quotation-preprod4/',
    pnqLoginApiBaseUrl: '//test.airtel.in/ks/app/b2b-pricing-quotation-preprod4/',

    selfcareHelpPageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/',
    selfcareProfilePageUrl: 'https://test.airtel.in/b2b-t1/business/enterprise-hub/data/dashboard/profile/',
    homePageUrl: 'https://test.airtel.in/acquisition/acq/online-acquisition/',
    dedicatedhomePageUrl: 'https://www.airtel.in/business/b2b/internet-leased-line',
    selfcareBasePageUrl: 'https://test.airtel.in/atb-integration/business/enterprise-hub/data/dashboard/',
    aehdashboardUrl: 'https://test.airtel.in/b2b-t1/business/enterprise-hub/data/dashboard',
    oftApiBaseUrl: '//test.airtel.in/ks/app/b2b-api-t1/b2b-oft/',
    //oftApiBaseUrl: "https://digi-api.airtel.in/b2b-oft/",
    //dedicatedoftApiBaseUrl:  "https://digi-api.airtel.in/b2b-oft/",
    dedicatedoftApiBaseUrl: '//test.airtel.in/kas/app/b2b-api-t1/b2b-oft/',
    otpApiBaseUrl:
      'http://10.5.245.149:8081/passport/services/oauth/v1_1/authorize?response_type=code&client_id=b2b_dsl_sit&redirect_uri=http://125.16.74.78/business/acq/online-acquisition/check-feasibility',
    autocomplete: 'https://digi-api.airtel.in/compassLocation/rest/',
    authClientId: 'b2b_dsl_sit',
    authRedirectUri: 'https://test.airtel.in/acquisition/acq/online-acquisition//check-feasibility',
    getCitiesUrl: 'http://10.5.204.217/telemedia-broadband/rest/bbData/',
    profileUnauthBaseUrl: 'https://test.airtel.in/kas/app/b2b-api-t1/airtel-b2b-profile/rest/',
    profileBaseUrl: 'https://test.airtel.in/ks/app/b2b-api-t1/airtel-b2b-profile/rest/',
    notificationBaseUrl: 'https://test.airtel.in/ks/app/b2b-api-t1/b2b-notification-manager/rest/',
    dataManageAccountBasePageUrl: 'https://test.airtel.in/b2b-t1/user/',
    mobilityManageAccountBasePageUrl: 'https://test.airtel.in/b2b-t1/cocp-admin-billing/profile',
    changePasswordBasePageUrl: 'https://test.airtel.in/b2b-t1/cocp-admin-billing/change-password',
    gettingStartedBasePageUrl: 'https://test.airtel.in/b2b-t1/help-support/lob/lob_enterprisehub#category_enterprisehub_level1_gettingstarted',
    helpAndSupportBasePageUrl: 'https://test.airtel.in/b2b-t1/help-support/',
    moreResourcesBasePageUrl: '',
    payDataBasePageUrl: 'https://test.airtel.in/b2b-t1/billing/',
    circuitsBasePageUrl: 'https://test.airtel.in/b2b-t1/circuits/',
    dataSRBasePageUrl: 'https://test.airtel.in/b2b-t1/sr/sr/',
    dataTrackOrderBasePageUrl: 'https://www.airtel.in/business/b2b/acquisition/track-order',
    cocpBillingBasePageUrl: 'https://test.airtel.in/b2b-t1/cocp-admin-billing/mobility/billing/',
    cocpConnectionBasePageUrl: 'https://test.airtel.in/b2b-t1/cocp-admin-connections/mobility/connection',
    cocpSRBaseUrl: 'https://test.airtel.in/aeh-uat2/cocp-sr/',
    cocpTrackOrderBasePageUrl: 'https://test.airtel.in/b2b-t1/trackorder/track-order/',
    gsuiteManageUsersUrl: 'https://test.airtel.in/blackforest-preprod/manage-users',
    thanksBasePageUrl: 'https://test.airtel.in/b2b-t1/b2b-thanks-ui/thanks-connections',
    buyBroadbandBaseUrl: 'https://www.airtel.in/business/b2b/acquisition/corporate-broadband/',
    oftCheckFeasibilityApi: '//test.airtel.in/kas/app/b2b-api-t1/b2b-oft/feasibility/common-widget/check',
    recommendedFeasibilityOftApi: '//test.airtel.in/kas/app/b2b-api-t1/b2b-oft/',
    staticAssetsUrl: 'https://devassets.airtel.com/static-assets/thanksforbusiness-ui/',

    kamTrackLeadPage: 'https://test.airtel.in/business/b2b/acquisition/track-order/requests',
    kycApiBaseUrl: '//test.airtel.in/kas/app/b2b-api/b2b-kyc/',
    selfcareLoginPageBaseUrl: 'https://test.airtel.in/atb-integration/business/thanksforbusiness/login/',
    directVPNPageUrl: 'https://www.airtel.in/business/b2b/direct-vpn',
    getCityByPincodeApi: '//test.airtel.in/kas/app/b2b-api-t1/b2b-oft/pincodeMaster',
    ovapiBaseUrl: 'http://10.5.245.145:8006/b2b-ov'
  },
  // [ENV_NAME.DEV]: {
  //   env: ENV_NAME.DEV,
  //   apiBaseUrl: MODULE.DEV.COCP,
  //   apiCallAEHUrl: MODULE.DEV.COCP,
  //   pnqapiBaseUrl: MODULE.DEV.PNQ,
  //   pnqLoginApiBaseUrl: MODULE.DEV.PNQ,
  //   dedicatedSummaryApiUrl: MODULE.DEV.KYC,
  //   dedicatedSummaryAuthApiUrl: MODULE.DEV.KYC,
  //   oftApiBaseUrl: MODULE.DEV.OFT,
  //   dedicatedoftApiBaseUrl: MODULE.DEV.OFT,
  //   // oftCheckFeasibilityApi: "https://digi-api.airtel.in/b2b-oft/feasibility/common-widget/check",
  //   oftCheckFeasibilityApi: `${MODULE.DEV.OFT}feasibility/common-widget/check`,
  //   recommendedFeasibilityOftApi: MODULE.DEV.OFT,
  //   baseAssetsUrl: 'http://localhost/web-static-content/static-assets/',
  //   aehdashboardUrl: 'https://test.airtel.in/atb-integration/business/enterprise-hub/data/dashboard',
  //   otpApiBaseUrl: 'http://10.5.245.149:8081/passport/services/oauth/v1_1/authorize?response_type=code&client_id=b2b_dsl_dev&redirect_uri=http://localhost:3001/check-feasibility',
  //   selfcareHelpPageUrl: 'https://www.airtel.in/business/b2b/cocp-help',
  //   selfcareProfilePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/user/profile/',
  //   selfcareBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare//',
  //   selfcareLoginPageBaseUrl: 'https://www.airtel.in/business/thanksforbusiness/login/',
  //   homePageUrl: 'http://10.5.204.111/longurl/online-acquisition/check-feasibility',
  //   dedicatedhomePageUrl: 'https://www.airtel.in/business/b2b/internet-leased-line',
  //   autocomplete: 'https://digi-api.airtel.in/compassLocation/rest/',
  //   authClientId: 'b2b_dsl_dev',
  //   authRedirectUri: 'http://10.5.204.111/longurl/online-acquisition/check-feasibility',
  //   getCitiesUrl: 'http://10.5.204.217/telemedia-broadband/rest/bbData',
  //   profileUnauthBaseUrl: ' https://test.airtel.in/kas/app/atb-integration/airtel-b2b-profile/rest/',
  //   profileBaseUrl: 'https://test.airtel.in/b2b-t1/airtel-b2b-profile/rest/',
  //   notificationBaseUrl: 'https://test.airtel.in/b2b-t1/b2b-notification-manager/rest/',
  //   dataManageAccountBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/data/user/',
  //   mobilityManageAccountBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/user/profile',
  //   changePasswordBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/change-password',
  //   gettingStartedBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/help/lob/lob_enterprisehub#category_enterprisehub_level1_gettingstarted',
  //   helpAndSupportBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/help/',
  //   moreResourcesBasePageUrl: '',
  //   payDataBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/data/billing/',
  //   circuitsBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/data/circuits/',
  //   dataSRBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/data/sr/',
  //   dataTrackOrderBasePageUrl: 'https://www.airtel.in/business/b2b/acquisition/track-order',
  //   cocpBillingBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/mobility/billing/',
  //   cocpConnectionBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/connections/',
  //   cocpSRBaseUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/mobility/sr/',
  //   cocpTrackOrderBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/connections/mobility/connection/order/track',
  //   gsuiteManageUsersUrl: 'https://www.airtel.in/business/enterprise-hub/marketplace/manage-users',
  //   thanksBasePageUrl: 'https://www.airtel.in/business/enterprise-hub/thanks/thanks-connections',
  //   buyBroadbandBaseUrl: 'https://www.airtel.in/business/b2b/acquisition/corporate-broadband/',
  //   staticAssetsUrl: 'https://devassets.airtel.com/static-assets/thanksforbusiness-ui/',
  //   kamTrackLeadPage: 'https://test.airtel.in/business/b2b/acquisition/track-order/requests',
  //   kycApiBaseUrl: '//125.16.74.96/gateway/api/b2b/b2b-kyc/',
  //   directVPNPageUrl: 'https://www.airtel.in/business/b2b/direct-vpn',
  //   getCityByPincodeApi: 'http://125.16.74.96/gateway/preprod/b2b-oft/pincodeMaster',
  //ovapiBaseUrl: 'http://localhost:8586/b2b-ov'
  // }
  // Uncomment below for old dev configuration.
  [ENV_NAME.DEV]: {
    env: ENV_NAME.DEV,
    baseAssetsUrl: 'http://localhost/web-static-content/static-assets/',
    // apiBaseUrl: 'http://10.5.245.150:8012/b2b-cocp-acquisition/', // QA
    apiBaseUrl: 'http://10.241.150.189:8012/b2b-cocp-acquisition/',
    // apiBaseUrl: 'http://10.241.150.189:8012/b2b-cocp-acquisition/', // preprod4 (for Bulk Upgrade development)
    // dedicatedSummaryApiUrl: 'http://10.241.150.189:8080/b2b-acquisition-kyc/',
    //apiBaseUrl: 'http://10.241.150.189:8012/b2b-cocp-acquisition/', // temp for multi site feature development
    // dedicatedSummaryApiUrl: 'http://10.241.99.232:8090/b2b-acquisition-kyc/', // preProd2
    dedicatedSummaryApiUrl: 'http://10.241.99.233:8080/b2b-acquisition-kyc/', // qa2
    // dedicatedSummaryApiUrl: 'http://10.241.150.189:8080/b2b-acquisition-kyc/',
    dedicatedSummaryAuthApiUrl: 'http://10.241.150.189:8080/b2b-acquisition-kyc/',
    dedicatedSummaryAuthApiUrl: 'http://10.241.150.189:8080/b2b-acquisition-kyc/',
    apiCallAEHUrl: 'http://10.5.245.150:8012/b2b-cocp-acquisition/',
    //oftApiBaseUrl: "http://10.5.245.150:8009/b2b-oft/",
    oftApiBaseUrl: 'http://10.5.203.247:8000/gateway/preprod/b2b-oft/',
    // dedicatedoftApiBaseUrl: 'http://10.5.245.150:8009/b2b-oft/',
    // dedicatedoftApiBaseUrl: 'http://10.5.245.148:8009/b2b-oft/',
    dedicatedoftApiBaseUrl: '//test.airtel.in/kas/app/b2b-api-t1/b2b-oft/',

    aehdashboardUrl: 'https://test.airtel.in/atb-integration/business/enterprise-hub/data/dashboard',
    otpApiBaseUrl: 'http://10.5.245.149:8081/passport/services/oauth/v1_1/authorize?response_type=code&client_id=b2b_dsl_dev&redirect_uri=http://localhost:3001/check-feasibility',
    selfcareHelpPageUrl: 'https://www.airtel.in/business/b2b/cocp-help',
    selfcareProfilePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/user/profile/',
    selfcareBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare//',
    selfcareLoginPageBaseUrl: 'https://www.airtel.in/business/thanksforbusiness/login/',
    homePageUrl: 'http://10.5.204.111/longurl/online-acquisition/check-feasibility',
    dedicatedhomePageUrl: 'https://www.airtel.in/business/b2b/internet-leased-line',
    autocomplete: 'https://digi-api.airtel.in/compassLocation/rest/',
    authClientId: 'b2b_dsl_dev',
    authRedirectUri: 'http://10.5.204.111/longurl/online-acquisition/check-feasibility',
    getCitiesUrl: 'http://10.5.204.217/telemedia-broadband/rest/bbData',
    // oftCheckFeasibilityApi: 'http://10.5.245.148:8009/b2b-oft/feasibility/common-widget/check',
    // recommendedFeasibilityOftApi: 'http://10.5.245.148:8009/b2b-oft/',
    oftCheckFeasibilityApi: '//test.airtel.in/kas/app/b2b-api-t1/b2b-oft/feasibility/common-widget/check',
    recommendedFeasibilityOftApi: '//test.airtel.in/kas/app/b2b-api-t1/b2b-oft/',
    // profileUnauthBaseUrl: 'https://test.airtel.in/kas/app/b2b-api-t1/airtel-b2b-profile/rest/',
    // profileUnauthBaseUrl: 'http://10.5.244.126:8006/airtel-b2b-profile/rest/',
    profileUnauthBaseUrl: ' https://test.airtel.in/kas/app/atb-integration/airtel-b2b-profile/rest/',
    profileBaseUrl: '//test.airtel.in/b2b-t1/airtel-b2b-profile/rest/',
    notificationBaseUrl: 'https://test.airtel.in/b2b-t1/b2b-notification-manager/rest/',
    dataManageAccountBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/data/user/',
    mobilityManageAccountBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/user/profile',
    changePasswordBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/change-password',
    gettingStartedBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/help/lob/lob_enterprisehub#category_enterprisehub_level1_gettingstarted',
    helpAndSupportBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/help/',
    moreResourcesBasePageUrl: '',
    payDataBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/data/billing/',
    circuitsBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/data/circuits/',
    dataSRBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/data/sr/',
    dataTrackOrderBasePageUrl: 'https://www.airtel.in/business/b2b/acquisition/track-order',
    cocpBillingBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/mobility/billing/',
    cocpConnectionBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/connections/',
    cocpSRBaseUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/data/mobility/sr/',
    cocpTrackOrderBasePageUrl: 'https://www.airtel.in/business/thanksforbusiness/selfcare/connections/mobility/connection/order/track',
    gsuiteManageUsersUrl: 'https://www.airtel.in/business/enterprise-hub/marketplace/manage-users',
    thanksBasePageUrl: 'https://www.airtel.in/business/enterprise-hub/thanks/thanks-connections',
    buyBroadbandBaseUrl: 'https://www.airtel.in/business/b2b/acquisition/corporate-broadband/',
    staticAssetsUrl: 'https://devassets.airtel.com/static-assets/thanksforbusiness-ui/',
    // pnqapiBaseUrl: 'http://10.241.99.233:8018/b2b-pricing-quotation/',
    pnqapiBaseUrl: 'http://10.5.245.150:8018/b2b-pricing-quotation/',
    pnqLoginApiBaseUrl: 'http://10.5.245.150:8018/b2b-pricing-quotation/',
    pnqget: 'http://10.5.29.192:8084/b2b-pricing-quotation/',
    kamTrackLeadPage: 'https://test.airtel.in/business/b2b/acquisition/track-order/requests',
    //kycApiBaseUrl: '//125.16.74.96/gateway/api/b2b/b2b-kyc/',
    kycApiBaseUrl: 'https://digi-api.airtel.in/b2b-kyc/',
    directVPNPageUrl: 'https://www.airtel.in/business/b2b/direct-vpn',
    getCityByPincodeApi: 'http://125.16.74.96/gateway/preprod/b2b-oft/pincodeMaster',
    getCityByPincodeApi: 'https://digi-api.airtel.in/b2b-oft/pincodeMaster',
    ovapiBaseUrl: 'http://10.5.245.145:8006/b2b-ov'
    //ovapiBaseUrl: '//test.airtel.in/as/app/b2b-ov'
  }
};

const bootstrapEnv = () => {
  const env = _Environment[process.env.REACT_APP_ENV || ENV_NAME.DEV];
  Environment.setEnv(env);
  return env;
};
export default bootstrapEnv();
